var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"board__item pnt",on:{"click":_vm.goDetail}},[_c('div',{staticClass:"txt_wrap"},[(_vm.isNew())?_c('span',{staticClass:"new"},[_c('img',{attrs:{"src":require(`@/assets/front/images/i_new2.svg`),"alt":""}})]):_vm._e(),_c('p',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.colorWord(_vm.data.title))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }